<template>
  <avs-card>
    <template v-slot:title>
      <div
        class="secondary--text text-h6 font-weight-bold"
        @click="onHomeIconClick"
        style="cursor: pointer"
      >
        <v-icon
          color="primary"
          class="mb-2"
          size="25"
          >mdi-home</v-icon
        >
        {{ $tc("commons.folder", 2) }}
      </div>

      <!-- Actions -->
      <div class="d-flex justify-end">
        <!-- Upload file -->

        <avs-button
          fab
          iconI="mdi-upload"
          icon
          label
          small
          color="secondary"
          :disabled="isLocked"
          @click="open('DialogFileUpload')"
          :spantext="$t('actions.upload', { entity: $tc('commons.file', 1).toLowerCase() })"
        />

        <!-- Remove folder -->
        <avs-deleteButton
          :disabled="isLocked"
          @click="open('DialogDeleteFolder')"
          :spantext="$t('actions.delete', { entity: $tc('commons.folder', 1).toLowerCase() })"
        />

        <!-- Add folder -->
        <!-- <MenuMkDir @created="initialize" /> -->
        <MenuMkDir
          @created="initialize"
          :folder="selectedFolder"
          :isLocked="isLocked"
        />
      </div>

      <!-- Report actions -->
      <v-switch
        hide-details
        inset
        color="accent"
        :label="$t('actions.report')"
        :value="isModeReport"
        @change="onReportModeChange"
      ></v-switch>
    </template>

    <template v-slot:content>
      <div class="custom-item"><v-divider></v-divider></div>

      <!-- CONTENT -->
      <div class="d-flex flex-wrap">
        <div :class="klass.col1">
          <FolderList
            :value="items"
            @hasChanged="onFolderChange"
            @toRename="openRename"
          />
        </div>
        <v-divider vertical></v-divider>
        <div :class="klass.col2">
          <FolderContent
            ref="folderContent"
            :value="selectedFolder"
            :isLoading="isLoading"
            :mode="mode"
            :selected="selectedFiles"
            @hasChanged="initialize"
            @selectChange="onSelectChange"
            @upload="open('DialogFileUpload')"
          />
        </div>
        <v-divider vertical></v-divider>
        <div :class="klass.col3">
          <ReportBuilder
            v-if="isModeReport"
            :value="selectedFiles"
            @hasChanged="onSelectChange"
            @created="onReportCreate"
          />
        </div>
      </div>

      <!-- Upload file dialog -->
      <component
        v-model="isDialogOpen"
        :folder="selectedFolder"
        :is="dialogContent"
        :item="editedItem"
        @close="close"
      />

      <component
        v-model="isDialogOpenRename"
        :is="dialog"
        :item="selectedFolder"
        :isFolder="true"
        :folder="selectedFolder"
        :title="$t('commons.rename')"
        @hasChanged="initialize"
        @close="closeDialog"
      />
    </template>
  </avs-card>
</template>

<script>
import DocumentationService from "@/services/DocumentationService"

import {
  DialogFileUpload,
  DialogDeleteFolder,
  FolderContent,
  FolderList,
  MenuMkDir,
  ReportBuilder,
  EditDocumentDialog
} from "@/components"

export default {
  components: {
    DialogDeleteFolder,
    DialogFileUpload,
    FolderContent,
    FolderList,
    MenuMkDir,
    ReportBuilder,
    EditDocumentDialog
  },
  name: "Documentation",
  props: {},
  data: function () {
    return {
      dialog: null,
      dialogContent: null,
      isDialogOpen: false,
      isDialogOpenRename: false,
      isLoading: true,
      isModeReport: false,
      items: [],
      selectedFolderIndex: -1,
      selectedFiles: [],
      editedItem: null
    }
  },
  created() {
    this.initialize()
  },
  computed: {
    klass() {
      return this.isModeReport
        ? { col1: "col-md-3 col-4", col2: "col-md-6 col-8", col3: "col-md-3 col-12" }
        : { col1: "col-md-4 col-12", col2: "col-md-8 col-12", col3: "col-md-0 col-0" }
    },
    isLocked() {
      return !this.selectedFolder?.id
    },
    mode() {
      return this.isModeReport ? "report" : "standard"
    },
    projectId() {
      return this.$store.state.app.project.id
    },
    selectedFolder() {
      return this.items[this.selectedFolderIndex]
    },
    showPcqDsi() {
      return this.$store.state.app.project.show_pcq_dsi
    }
  },
  methods: {
    closeDialog(hasChanged) {
      if (hasChanged) this.$emit("hasChanged")
      this.dialog = null
      this.editedItem = null
      this.isDialogOpen = false
    },
    onHomeIconClick() {
      // Réinitialiser l'index du dossier sélectionné
      let new_index = -1
      this.onSelectChange(new_index)
      this.selectedFolderIndex = -1
      this.removeActiveClass()
    },
    removeActiveClass() {
      const activeNodes = document.querySelectorAll(".v-treeview-node--active")
      activeNodes.forEach(node => {
        node.classList.remove("v-treeview-node--active")
      })
    },
    fetchDocumentation() {
      this.isLoading = true
      DocumentationService.projectTree(this, this.projectId)
        .then(data => {
          // this.items = data
          if (this.showPcqDsi) {
            this.items = data
          } else {
            this.items = data.filter(item => item.key !== "pcq_dsis'")
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onReportCreate(newItem) {
      this.initialize()
      this.$refs.folderContent.openViewer(newItem)
      this.onReportModeChange(false)
    },
    onReportModeChange(newValue) {
      this.isModeReport = newValue
      if (!newValue) this.selectedFiles = []
    },
    onSelectChange(newSelection) {
      this.selectedFiles = newSelection
    },
    onFolderChange(newValue) {
      this.selectedFolderIndex = newValue
    },
    close(hasChange) {
      if (hasChange) this.initialize()
      this.dialogContent = null
      this.isDialogOpen = false
      this.isDialogOpenRename = false
    },
    open(name) {
      this.dialogContent = name
      this.isDialogOpen = true
      this.isDialogOpenRename = false
    },
    openRename(item) {
      this.editedItem = item
      this.dialog = "EditDocumentDialog"
      this.isDialogOpenRename = true
      this.selectedFolderIndex = item.id
    },
    initialize() {
      this.fetchDocumentation()
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-container {
  display: flex;
  flex-direction: column;
  min-height: 75vh;
}

.custom-item {
  flex: 0 0 auto;
}
</style>
